<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>company.wip-login.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <form>
        <div class="vox-input-group vox-input-group_dense">
          <input class="vox-text-field"
            [placeholder]="'company.wip-login.placeholder' | translate"
            [formControl]="branch"
          />
        </div>
        <div class="d-flex flex-row justify-content-between mt-3">
          <button class="vox-btn vox-btn-secondary"
            [disabled]="branch.invalid"
            (click)="copyWIP()"
            [ngbTooltip]="'common.copied-link' | translate"
            triggers="manual"
            type="button"
            #t="ngbTooltip">
            <span translate>common.copy-link</span>
          </button>
          <button class="vox-btn vox-btn-secondary" [disabled]="branch.invalid" (click)="openWIP()">
            <span translate>company.wip-login.login</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
